export const SET_USER_SETTINGS = "SET_USER_SETTINGS"
export const SET_PEOFILE_USER_SETTINGS = "SET_PEOFILE_USER_SETTINGS"